import {useNotifications} from "../../context/NotificationContext";
import {useMutation} from "react-query";
import {NewNoteData, NoteFormData} from "../../types/Note";
import ngage from "../../services/ngage";
import {FormikHelpers} from "formik";
import {invalidate} from "../../services/query-client";
import {stripKeyFromObject} from "../../services/object";

export function useStoreNote() {
  const {notify} = useNotifications();
  const store = useMutation((data: NewNoteData) => ngage.notes.store(data));

  async function storeNote(values: NoteFormData, formik: FormikHelpers<NoteFormData>) {
    try {
      const noteData = stripKeyFromObject(values, 'mode') as NewNoteData;

      // Make the note and invalidate the note cache
      await store.mutateAsync(noteData);
      await invalidate('notes.all');

      // Mark the form as having been submitted
      formik.setSubmitting(false);

      // Notify the user
      notify("success", "Note Created", `${values.title} has been created`);
      return true;
    } catch (error) {
      notify("error", "Note Not Created", `${values.title} could not be stored`);
      throw error;
    }
  }

  return storeNote;
}